export default "__VITE_ASSET__B4igvS9e__"